import vsf, { definePage } from '@vs/vsf-boot';
import { Page } from '@vs/vsf-kit';
import React from 'react';

const Service = (props) => {
  return <Page title="Service"></Page>;
};

export default definePage(Service);
